import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { CONTACT, IMAGES } from "@/data/content";

export default function Contact() {
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      {/* Left — image + details */}
      <div className="relative bg-charcoal text-white flex flex-col justify-between pt-32 md:pt-40 pb-16 px-6 md:px-12 lg:px-16 overflow-hidden">
        <img src={IMAGES.concreteStairs} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative">
          <Overline light className="mb-6">Start Your Project</Overline>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-extrabold leading-[0.92] tracking-tighter">Let's Build<br />Something<br /><span className="text-sand">Remarkable.</span></h1>
          <p className="mt-8 text-white/70 font-light leading-relaxed max-w-md">Share your project details and we'll provide a comprehensive, obligation-free quote within one business day.</p>
        </div>
        <div className="relative mt-16 space-y-6">
          <a href={CONTACT.phoneHref} data-testid="contact-phone" className="flex items-center gap-4 hover:text-sand transition-colors">
            <Phone className="h-5 w-5 text-sand" strokeWidth={1.5} />
            <span className="font-display text-2xl font-bold">{CONTACT.phone}</span>
          </a>
          <div className="flex items-center gap-4 text-white/80"><Clock className="h-5 w-5 text-sand" strokeWidth={1.5} /> {CONTACT.hours}</div>
          <a href={`mailto:${CONTACT.email}`} data-testid="contact-email" className="flex items-center gap-4 text-white/80 hover:text-sand transition-colors"><Mail className="h-5 w-5 text-sand" strokeWidth={1.5} /> {CONTACT.email}</a>
          <div className="flex items-center gap-4 text-white/80"><MapPin className="h-5 w-5 text-sand" strokeWidth={1.5} /> {CONTACT.location}</div>
        </div>
      </div>

      {/* Right — form */}
      <div className="bg-white pt-28 md:pt-40 pb-20 px-6 md:px-12 lg:px-16 flex flex-col justify-center">
        <Reveal>
          <Overline className="mb-8">Get a Free Quote</Overline>
          <EnquiryForm />
        </Reveal>
      </div>
    </div>
  );
}
